<script lang="ts" setup>
import BaseButton from "@/components/base/BaseButton.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import AddonsDetails from "@/components/addons/AddonsDetails.vue";
import { useAddonsPage } from "@/composables/addons/useAddonsPage";
import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

const { t } = useI18n();
const {
  addAddon,
  availableAddons,
  chosenAddon,
  closeAddModal,
  closeAllModal,
  computeAddonTitle,
  isAddonDetails,
  isAddAddon,
  isAlreadyAdded,
  isIncompatible,
  isLoading,
  isSticky,
  isSuccessful,
  isUnhandledError,
  isUnsuccessful,
  pageTitle,
  configDataBrand,
  showDetails,
  startAddonAction,
  toPayment,
} = useAddonsPage();
</script>

<template>
  <div class="addons">
    <div class="addons-header">
      <router-link v-if="!isAddonDetails" to="account">
        <div class="addons-header__back">
          <BaseFigureForIcon
            size="medium"
            color="white"
            icon="arrow"
            position="left"
            is-button
          />
        </div>
      </router-link>
      <div
        v-if="isAddonDetails"
        class="addons-header__back"
        @click="isAddonDetails = false"
      >
        <BaseFigureForIcon
          size="medium"
          color="white"
          icon="arrow"
          position="left"
          is-button
        />
      </div>
      <div class="addons-header__title" :class="isSticky ? 'visible' : ''">
        <p class="h3">{{ pageTitle }}</p>
      </div>
      <BaseFigureForIcon
        v-if="isAddonDetails"
        class="addons-header__close"
        icon="close"
        color="white"
        size="medium"
        is-button
        @click="isAddonDetails = false"
      />
    </div>
    <div v-if="!isAddonDetails" class="addons-mobile_header">
      <p class="h1">{{ pageTitle }}</p>
    </div>
    <template v-if="!isAddonDetails">
      <div v-if="!isLoading" class="addons-body">
        <div
          v-for="(item, index) in availableAddons"
          :key="index"
          class="addons-item"
        >
          <div class="addons-item--title">
            <p class="caption-large--bold">{{ item.name }}</p>
          </div>
          <div class="addons-item--description">
            <p
              v-if="Math.floor(parseInt(item.activation_price)) > 0"
              class="caption-medium color-text-secondary"
            >
              {{ item.activation_price }}₽
              {{ t("common.labels.perMonth") }}
            </p>
            <p v-else class="caption-medium color-text-secondary">
              {{ t("common.labels.free") }}
            </p>
          </div>
          <div class="addons-item--actions">
            <div class="addons-item--btn">
              <BaseButton
                size="small"
                :title="t('common.actions.details')"
                color="grey"
                @click="showDetails(item)"
              />
            </div>
            <div class="addons-item--btn">
              <BaseButton
                size="small"
                :title="t('common.actions.connect')"
                @click="startAddonAction(item)"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="addons-loader">
        <div class="addons-loader-pic">
          <img :src="configDataBrand.assets.loader" alt="Загрузка" />
        </div>
      </div>
    </template>
    <template v-if="isAddonDetails && chosenAddon">
      <AddonsDetails :chosen-addon="chosenAddon" @action="startAddonAction" />
    </template>
  </div>
  <Teleport to=".root">
    <BaseModal
      v-if="isAddAddon && chosenAddon"
      :title="computeAddonTitle(chosenAddon)"
      :main-btn-title="t('common.actions.yes')"
      :secondary-btn-title="t('common.actions.no')"
      @close="closeAddModal"
      @action="addAddon(chosenAddon.ems_product_id)"
      @secondary-action="closeAddModal"
    />
    <BaseModal
      v-if="isSuccessful"
      :title="t('addons.modals.successTitle')"
      :main-btn-title="t('common.actions.ok')"
      @close="closeAllModal"
      @action="closeAllModal"
    />
    <BaseModal
      v-if="isUnsuccessful"
      :title="t('addons.modals.insufficientFundsTitle')"
      :text="t('addons.modals.insufficientFundsText')"
      :main-btn-title="t('common.buttons.topUpBalance')"
      @close="closeAllModal"
      @action="toPayment"
    />
    <BaseModal
      v-if="isUnhandledError"
      :title="t('common.errors.title')"
      :text="t('common.errors.retryRequest')"
      :main-btn-title="t('common.actions.ok')"
      @close="closeAllModal"
      @action="closeAllModal"
    />
    <BaseModal
      v-if="isIncompatible"
      :title="t('common.errors.title')"
      :text="t('addons.modals.incompatibleText')"
      :main-btn-title="t('common.actions.ok')"
      @close="closeAllModal"
      @action="closeAllModal"
    />
    <BaseModal
      v-if="isAlreadyAdded"
      :title="t('common.errors.title')"
      :text="t('addons.modals.alreadyAddedText')"
      :main-btn-title="t('common.actions.ok')"
      @close="closeAllModal"
      @action="closeAllModal"
    />
  </Teleport>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/addons";
</style>
